<template>
  <section>
    <div class="botones-pagina">
      <print-btn/>
    </div>
    <div class="chartContainer">
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">Notas por tipo de medio</h3>
        <h5 class="h5 text--uppercase text--center text--gris8">Sólo notas directas</h5>
        <doughnut-chart :chart-data="chartDataMedios"
                        :options="{responsive: false, maintainAspectRatio: false}"
                        :height="chartSettings.height" :width="chartSettings.width"/>
        <table class="tabla">
          <thead class="tabla__header">
            <tr>
              <th>Medio</th>
              <th>Cantidad</th>
              <th>Porcentaje</th>
            </tr>
          </thead>
          <tbody class="tabla__body">
            <tr v-for="(label, index) in chartDataMedios.labels" :key="index">
              <td>{{ label }}</td>
              <td>{{ chartDataMedios.datasets[0].data[index] }}</td>
              <td>{{ calcularPorcentaje(
                chartDataMedios.datasets[0].data[index],
                chartDataMedios.datasets[0].data) }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">Notas por sentimiento</h3>
        <h5 class="h5 text--uppercase text--center text--gris8">Sólo notas directas</h5>
        <doughnut-chart :chart-data="chartDataSentimiento"
                        :options="{responsive: false, maintainAspectRatio: false}"
                        :height="chartSettings.height" :width="chartSettings.width"/>
      </div>
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">Participación en el sector</h3>
        <h5 class="h5 text--uppercase text--center text--gris8">Todas las notas</h5>
        <doughnut-chart :chart-data="chartDataMencion"
                        :options="{responsive: false, maintainAspectRatio: false}"
                        :height="chartSettings.height" :width="chartSettings.width"/>
        <table class="tabla">
          <thead class="tabla__header">
            <tr>
              <th>Mención</th>
              <th>Cantidad</th>
              <th>Porcentaje</th>
            </tr>
          </thead>
          <tbody class="tabla__body">
            <tr v-for="(value, llave) in tableDataMencion" :key="llave">
              <td>{{ llave }}</td>
              <td>{{ value.cant }}</td>
              <td>{{ value.porc }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">Notas por tipo de mención, por día</h3>
        <bar-chart :chart-data="chartDataMencionXDia"
                   :options="{responsive: false, maintainAspectRatio: false}"/>
      </div>
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">
          Notas positivas y negativas, agrupadas por tipo de medio
        </h3>
        <h5 class="h5 text--uppercase text--center text--gris8">Sólo notas directas</h5>
        <bar-chart :chart-data="chartDataMedioSentimiento"
                   :options="{responsive: false, maintainAspectRatio: false}"/>
        <table class="tabla">
          <thead class="tabla__header">
            <tr>
              <th>Medio</th>
              <th>Positivas</th>
              <th>Neutras</th>
              <th>Negativas</th>
              <th>Total</th>
              <th>eVcom+</th>
            </tr>
          </thead>
          <tbody class="tabla__body">
            <tr>
              <td>Prensa</td>
              <td>{{ tableDataMedioSentimiento.prensa.positivas }}</td>
              <td>{{ tableDataMedioSentimiento.prensa.neutras }}</td>
              <td>{{ tableDataMedioSentimiento.prensa.negativas }}</td>
              <td>{{ tableDataMedioSentimiento.prensa.total }}</td>
              <td>{{ tableDataMedioSentimiento.prensa.evcom | colones }}</td>
            </tr>
            <tr>
              <td>Radio</td>
              <td>{{ tableDataMedioSentimiento.radio.positivas }}</td>
              <td>{{ tableDataMedioSentimiento.radio.neutras }}</td>
              <td>{{ tableDataMedioSentimiento.radio.negativas }}</td>
              <td>{{ tableDataMedioSentimiento.radio.total }}</td>
              <td>{{ tableDataMedioSentimiento.radio.evcom | colones }}</td>
            </tr>
            <tr>
              <td>Televisión</td>
              <td>{{ tableDataMedioSentimiento.television.positivas }}</td>
              <td>{{ tableDataMedioSentimiento.television.neutras }}</td>
              <td>{{ tableDataMedioSentimiento.television.negativas }}</td>
              <td>{{ tableDataMedioSentimiento.television.total }}</td>
              <td>{{ tableDataMedioSentimiento.television.evcom | colones }}</td>
            </tr>
            <tr>
              <td>Medios Digitales</td>
              <td>{{ tableDataMedioSentimiento.md.positivas }}</td>
              <td>{{ tableDataMedioSentimiento.md.neutras }}</td>
              <td>{{ tableDataMedioSentimiento.md.negativas }}</td>
              <td>{{ tableDataMedioSentimiento.md.total }}</td>
              <td>{{ tableDataMedioSentimiento.md.evcom | colones }}</td>
            </tr>
            <tr>
              <td>Redes Sociales</td>
              <td>{{ tableDataMedioSentimiento.rs.positivas }}</td>
              <td>{{ tableDataMedioSentimiento.rs.neutras }}</td>
              <td>{{ tableDataMedioSentimiento.rs.negativas }}</td>
              <td>{{ tableDataMedioSentimiento.rs.total }}</td>
              <td>{{ tableDataMedioSentimiento.rs.evcom | colones }}</td>
            </tr>
            <tr>
              <td><strong>Total general</strong></td>
              <td>{{ tableDataMedioSentimiento.totales.positivas }}</td>
              <td>{{ tableDataMedioSentimiento.totales.neutras }}</td>
              <td>{{ tableDataMedioSentimiento.totales.negativas }}</td>
              <td>{{ tableDataMedioSentimiento.totales.total }}</td>
              <td>{{ tableDataMedioSentimiento.totales.evcom | colones }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">Notas directas por día, por sentimiento</h3>
        <h5 class="h5 text--uppercase text--center text--gris8">Notas para el mes de {{ mes }}</h5>
        <line-chart :chart-data="chartDataMesSentimiento"
                    :options="{responsive: false, maintainAspectRatio: false}" />
        <table class="tabla">
          <thead class="tabla__header">
            <tr>
              <th>Fecha</th>
              <th>Positivas</th>
              <th>Negativas</th>
            </tr>
          </thead>
          <tbody class="tabla__body">
            <tr v-for="(value, llave) in tableDataMesSentimiento" :key="llave">
              <td>{{ llave }}</td>
              <td>{{ value.positiva || 0 }}</td>
              <td>{{ value.negativa || 0 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">Notas por medio</h3>
        <h5 class="h5 text--uppercase text--center text--gris8">Sólo notas directas</h5>
        <hbar-chart :chart-data="chartDataDesgloceMedios"
                    :options="{responsive: false, maintainAspectRatio: false,
                               scales: {
                                 xAxes: [{
                                   display: true,
                                   ticks: {
                                     beginAtZero: true // minimum value will be 0.
                                   }
                                 }]
        }}"/>
        <table class="tabla">
          <thead class="tabla__header">
            <tr>
              <th>Medio</th>
              <th>Cantidad</th>
            </tr>
          </thead>
          <tbody class="tabla__body">
            <tr v-for="(item, index) in tableDataDesgloceMedios" :key="index">
              <td>{{ item.nombre }}</td>
              <td>{{ item.cant }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">
          Notas por medio/programa, por sentimiento
        </h3>
        <h5 class="h5 text--uppercase text--center text--gris8">Sólo notas directas</h5>
        <hbar-chart :chart-data="chartDataDesgloceMediosSentimiento"
                    :options="{responsive: false, maintainAspectRatio: false}"/>
        <table class="tabla">
          <thead class="tabla__header">
            <tr>
              <th>Medio/Programa</th>
              <th>Positivas</th>
              <th>Negativas</th>
            </tr>
          </thead>
          <tbody class="tabla__body">
            <tr v-for="(item, index) in tableDataDesgloceMediosSentimiento" :key="index">
              <td>{{ item.nombre }}</td>
              <td>{{ item.positivas }}</td>
              <td>{{ item.negativas }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="panel fondo--blanco">

        <h3 class="h3 text--uppercase text--center">Notas por personaje</h3>
        <h5 class="h5 text--uppercase text--center text--gris8">
          Sólo se muestran los 10 personajes con mayor participación
        </h5>
        <hbar-chart :chart-data="chartDataPersonajes"
                    :options="{responsive: false, maintainAspectRatio: false}"/>
      </div>
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">Notas por entidad</h3>
        <h5 class="h5 text--uppercase text--center text--gris8">
          Sólo se muestran las 10 entidades con mayor participación
        </h5>
        <hbar-chart :chart-data="chartDataEntidades"
                    :options="{responsive: false, maintainAspectRatio: false}"/>
      </div>
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">Suma de eVcom por tipo de medio</h3>
        <hbar-chart
          :chart-data="chartEvcomXMedio"
          :options="{responsive: false, maintainAspectRatio: false}"
          :height="chartSettings.height" :width="chartSettings.width"/>
        <table class="tabla">
          <thead class="tabla__header">
            <tr>
              <th>Medio</th>
              <th>eVcom+</th>
            </tr>
          </thead>
          <tbody class="tabla__body">
            <tr v-for="(evcom, medio) in tableEvcomXMedio" :key="medio">
              <td>{{ medio }}</td>
              <td>{{ evcom | colones }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="panel fondo--blanco"
           v-for="(chart, medio) in chartEvcomXMedioPrograma" :key="medio">
        <h3 class="h3 text--uppercase text--center">Suma de eVcom por medio/programa</h3>
        <p class="h5 text--uppercase text--center text--gris8">{{ medio }}</p>
        <hbar-chart
          :chart-data="chartEvcomXMedioPrograma[medio]"
          :options="{responsive: false, maintainAspectRatio: false}"
          :height="chartSettings.height" :width="chartSettings.width"/>
        <table class="tabla">
          <thead class="tabla__header">
            <tr>
              <th>Medio/Programa</th>
              <th>Positivas eVcom</th>
            </tr>
          </thead>
          <tbody class="tabla__body">
            <tr v-for="(evcom, prog) in tableEvcomXMedioPrograma[medio]" :key="prog">
              <td>{{ prog }}</td>
              <td>{{ evcom | colones }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">Notas por tema</h3>
        <h5 class="h5 text--uppercase text--center text--gris8">
          Sólo se muestran los 10 temas con mayor participación
        </h5>
        <doughnut-chart :chart-data="chartDataTemas"
                        :options="{responsive: false, maintainAspectRatio: false}"/>
        <table class="tabla">
          <thead class="tabla__header">
            <tr>
              <th>Tema</th>
              <th>Cantidad</th>
            </tr>
          </thead>
          <tbody class="tabla__body">
            <tr v-for="(item, index) in tableDataTemas" :key="index">
              <td>{{ item.nombre }}</td>
              <td>{{ item.cant }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="panel fondo--blanco">
        <h3 class="h3 text--uppercase text--center">Notas por tipo de fuente, por sentimiento</h3>
        <h5 class="h5 text--uppercase text--center text--gris8">Sólo notas directas</h5>
        <bar-chart :chart-data="chartDataFuentes"
                   :options="{responsive: false, maintainAspectRatio: false}"/>
        <table class="tabla">
          <thead class="tabla__header">
            <tr>
              <th>Categoría de Fuente</th>
              <th>Positiva</th>
              <th>Negativa</th>
            </tr>
          </thead>
          <tbody class="tabla__body">
            <tr v-for="(val, fuente) in tableDataFuentes" :key="fuente">
              <td>{{ fuente }}</td>
              <td>{{ val.positivas }}</td>
              <td>{{ val.negativas }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
import D from "debug";
import keys from "lodash/keys";
import map from "lodash/map";
import sum from "lodash/sum";
import values from "lodash/values";
import moment from "moment";
import DoughtnutChart from "../util/doughnutChart.vue";
import BarChart from "../util/barChart.vue";
import HBarChart from "../util/hbarChart.vue";
import LineChart from "../util/lineChart.vue";
import notasApi from "../notas/rest/notasApi";

const debug = D("ciris:Grafos.vue");

const colores = ["#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#f44336", "#e91e63", "#e5097f"];

function data() {
  return {
    chartSettings: { width: 300, height: 300 },
    chartDataMedios: {},
    chartDataSentimiento: {},
    chartDataMencion: {},
    chartDataMencionXDia: {},
    chartDataMedioSentimiento: {},
    chartDataMesSentimiento: {},
    chartEvcomXMedio: {},
    chartDataDesgloceMedios: {},
    chartDataDesgloceMediosSentimiento: {},
    chartEvcomXMedioPrograma: {},
    chartDataPersonajes: {},
    chartDataEntidades: {},
    chartDataTemas: {},
    chartDataFuentes: {},
    tableDataMedioSentimiento: {
      prensa: {}, radio: {}, television: {}, md: {}, rs: {},
    },
    tableDataMesSentimiento: {},
    tableDataMencion: {},
    tableDataDesgloceMedios: {},
    tableEvcomXMedio: {},
    tableDataDesgloceMediosSentimiento: {},
    tableEvcomXMedioPrograma: {},
    tableDataPersonajes: {},
    tableDataTemas: {},
    tableDataFuentes: {},
    mes: moment().locale("es").format("MMMM"),
    fechas: [moment()],
  };
}

function calcularPorcentaje(valor, valores) {
  const total = sum(valores);
  if (!total) {
    return 0;
  }
  return ((valor / total) * 100).toFixed(2);
}

function graficar(vm, resp) {
  llenarChartsViejos(vm, resp.chartsViejos);
  llenarChartMencionXDia(vm, resp.mencionXDia);
  llenarChartMedioSentimiento(vm, resp.medioSentimiento);
  llenarChartMesSentimiento(vm, resp.mesSentimiento);
  llenarChartEvcomXMedio(vm, resp.evcomXMedio);
  llenarChartDesgloceMedios(vm, resp.desgloceMedios);
  llenarChartDesgloceMediosSentimiento(vm, resp.desgloceMediosSentimiento);
  llenarChartEvcomXMedioPrograma(vm, resp.evcomXMedioPrograma);
  llenarChartPersonajes(vm, resp.personajes);
  llenarChartEntidades(vm, resp.entidades);
  llenarChartTemas(vm, resp.temas);
  llenarChartFuentes(vm, resp.fuentesSentimiento);
  vm.fechas = map(keys(resp.mencionXDia), v => moment(v));
}

function created() {
  this.$eventBus.$on("buscarNotas", this.buscarNotas);
  const credenciales = JSON.parse(localStorage.getItem("dashboard-controles"));
  return notasApi.getGraficos(credenciales.cliente._id, this.filtrosGlobales)
    .then(resp => graficar(this, resp))
    .catch(err => this.errorHandler(err));
}

function buscarNotas(filtros) {
  return notasApi.getGraficos(this.$auth.credenciales.cliente._id, filtros)
    .then(resp => graficar(this, resp));
}

function llenarChartFuentes(vm, resp) {
  vm.tableDataFuentes = resp;
  vm.chartDataFuentes = {
    labels: keys(resp),
    datasets: [{
      label: "Positivas",
      backgroundColor: "#4472c4",
      data: map(resp, "positivas"),
    },
    {
      label: "Negativas",
      backgroundColor: "#a5a5a5",
      data: map(resp, "negativas"),
    }],
  };
}

function llenarChartTemas(vm, resp) {
  vm.tableDataTemas = resp;
  vm.chartDataTemas = {
    labels: map(resp, "nombre"),
    datasets: [
      {
        label: "Cantidad",
        backgroundColor: colores,
        data: map(resp, "cant"),
      },
    ],
  };
}

function llenarChartEvcomXMedioPrograma(vm, resp) {
  const objChartData = medio => ({
    labels: keys(resp[medio]),
    datasets: [{
      label: "Total",
      backgroundColor: "#ee7e2e",
      data: values(resp[medio]),
    }],
  });
  vm.tableEvcomXMedioPrograma = resp;
  vm.chartEvcomXMedioPrograma = {
    Televisión: objChartData("Televisión"),
    Radio: objChartData("Radio"),
    Prensa: objChartData("Prensa"),
  };
}

function llenarChartEvcomXMedio(vm, resp) {
  vm.tableEvcomXMedio = resp;
  vm.chartEvcomXMedio = {
    labels: keys(resp),
    datasets: [{
      label: "Total",
      backgroundColor: "#ee7e2e",
      data: [
        resp.Prensa,
        resp.Radio,
        resp.Television,
      ],
    }],
  };
}

function llenarChartEntidades(vm, resp) {
  vm.chartDataEntidades = {
    labels: map(resp, "nombre"),
    datasets: [
      {
        label: "Cantidad",
        backgroundColor: "#4472c4",
        data: map(resp, "cant"),
      },
    ],
  };
}

function llenarChartPersonajes(vm, resp) {
  vm.chartDataPersonajes = {
    labels: map(resp, "nombre"),
    datasets: [
      {
        label: "Cantidad",
        backgroundColor: "#4472c4",
        data: map(resp, "cant"),
      },
    ],
  };
}

function llenarChartDesgloceMediosSentimiento(vm, resp) {
  vm.tableDataDesgloceMediosSentimiento = resp;
  vm.chartDataDesgloceMediosSentimiento = {
    labels: map(resp, "nombre"),
    datasets: [
      {
        label: "Positivas",
        backgroundColor: "#4472c4",
        data: map(resp, "positivas"),
      },
      {
        label: "Negativas",
        backgroundColor: "#ef473a",
        data: map(resp, "negativas"),
      },
    ],
  };
}

function llenarChartDesgloceMedios(vm, resp) {
  vm.tableDataDesgloceMedios = resp;
  vm.chartDataDesgloceMedios = {
    labels: map(resp, "nombre"),
    datasets: [
      {
        label: "Cantidad",
        backgroundColor: "#4472c4",
        data: map(resp, "cant"),
      },
    ],
  };
}

function llenarChartMesSentimiento(vm, resp) {
  vm.tableDataMesSentimiento = resp;
  vm.chartDataMesSentimiento = {
    labels: keys(resp),
    datasets: [
      {
        label: "Positivas",
        borderColor: "#4472c4",
        data: map(resp, "positiva"),
        spanGaps: true,
      },
      {
        label: "Negativas",
        borderColor: "#ef473a",
        data: map(resp, "negativa"),
        spanGaps: true,
      },
    ],
  };
}

function llenarChartMedioSentimiento(vm, resp) {
  vm.tableDataMedioSentimiento = resp;
  vm.chartDataMedioSentimiento = {
    labels: ["Prensa", "Radio", "Televisión", "Medios Digitales", "Redes Sociales"],
    datasets: [
      {
        label: "Positivas",
        backgroundColor: "#4472c4",
        data: map(resp, "positivas"),
      },
      {
        label: "Neutras",
        backgroundColor: "#ee7e2e",
        data: map(resp, "neutras"),
      },
      {
        label: "Negativas",
        backgroundColor: "#a5a5a5",
        data: map(resp, "negativas"),
      },
    ],
  };
}

function llenarChartMencionXDia(vm, resp) {
  vm.chartDataMencionXDia = {
    labels: map(keys(resp), v => moment(v).format("DD/MM/YYYY")),
    datasets: [
      {
        label: "Directas",
        backgroundColor: "#233586",
        data: map(resp, "directas"),
      },
      {
        label: "Competencia",
        backgroundColor: "#33cd5f",
        data: map(resp, "competencia"),
      },
      {
        label: "Contexto",
        backgroundColor: "#8cb91d",
        data: map(resp, "contexto"),
      },
    ],
  };
}

function llenarChartsViejos(vm, resp) {
  vm.chartDataMedios = {
    labels: ["Televisión", "Radio", "Prensa", "Medios Digitales", "Redes Sociales"],
    datasets: [
      {
        backgroundColor: ["#066dbc", "#ffc900", "#ef473a", "#8cb91d", "#673ab7"],
        data: [resp.television, resp.radio, resp.prensa, resp.md, resp.rs],
      },
    ],
  };
  vm.chartDataSentimiento = {
    labels: ["Negativas", "Positivas", "Neutrales"],
    datasets: [
      {
        backgroundColor: ["#ef473a", "#066dbc", "#999999"],
        data: [resp.negativas, resp.positivas, resp.neutrales],
      },
    ],
  };
  const valoresMencion = [resp.directas, resp.competencia, resp.contexto];
  vm.chartDataMencion = {
    labels: ["Directas", "Competencia", "Contexto"],
    datasets: [
      {
        backgroundColor: ["#233586", "#33cd5f", "#8cb91d"],
        data: valoresMencion,
      },
    ],
  };
  vm.tableDataMencion = {
    Directas: { cant: resp.directas, porc: calcularPorcentaje(resp.directas, valoresMencion) },
    Competencia: {
      cant: resp.competencia,
      porc: calcularPorcentaje(resp.competencia, valoresMencion),
    },
    Contexto: { cant: resp.contexto, porc: calcularPorcentaje(resp.contexto, valoresMencion) },
  };
}

function errorHandler(err) {
  debug(err);
  this.$toastr("error", "Algo sucedió procesando la información", "Ocurrió un error");
}

function beforeDestroy() {
  this.$eventBus.$off("buscarNotas", this.buscarNotas);
}

export default {
  components: {
    "doughnut-chart": DoughtnutChart,
    "bar-chart": BarChart,
    "line-chart": LineChart,
    "hbar-chart": HBarChart,
  },
  data,
  beforeDestroy,
  created,
  methods: {
    errorHandler,
    calcularPorcentaje,
    buscarNotas,
  },
  store: ["filtrosGlobales"],
};
</script>
<style lang="scss">
.chartContainer {
  column-count: 1;
  column-gap: 0;

  & > .panel {
    display: inline-block;
    width: 100%;
    margin: 1em 0;
  }
}

@media (min-width: 1080px) {
  .chartContainer {
    column-count: 2;
    column-gap: 1.5em;
    & > .panel {
      margin: 1em;
    }
  }
}

@media (min-width: 1400px) {
  .chartContainer {
    column-count: 3;
    column-gap: 2em;
  }
}

canvas {
  margin: 0 auto;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/grafos/Grafos.vue